import React from 'react';

import './index.css';

function Backdrop() {
    return <div className='backdrop' />
}

export default Backdrop;